import {Component, ContentChild, Input, OnInit, TemplateRef} from "@angular/core";
import {FUITree} from "./tree.model";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    /*
    animations: [
        trigger("slide", [
            state("void", style({
                height: 0,
                "margin-bottom": 0,
                "margin-top": 0,
                opacity: 0,
                overflow: "hidden",
                "padding-bottom": 0,
                "padding-top": 0
            })),
            state("true", style({})),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    */
    selector: "fui-tree",
    styleUrls: ["./tree.component.scss"],
    templateUrl: "./tree.component.html"
})
export class FUITreeComponent implements OnInit {
    @Input() public toggled: Map<string, boolean>;
    @Input() public tree: FUITree;
    @ContentChild("treeheadercontext", {read: TemplateRef}) public treeHeaderContext: TemplateRef<HTMLTemplateElement>;

    ngOnInit() {
        if (this.tree.open && this.tree.trees.length > 0) {
            this.toggled.set(this.tree.id, true);
        }
    }

    /**
     * Check if an item has been toggled (added
     * to active array) and return a boolean
     * result to indicate state
     * @param tree
     * @returns {boolean}
     */
    isToggled(tree: FUITree): boolean {
        return this.toggled.get(tree.id);
    }

    /**
     * Toggle the visibility of a group
     * of items
     * @param tree
     */
    toggle(tree: FUITree): void {
        if (tree.trees.length > 0) {
            this.toggled.set(tree.id, !this.isToggled(tree));
        }
    }

    /**
     *
     * @param index
     * @param item
     */
    trackByFn(index, item) {
        return item.id;
    }
}
